import { TransportResponsibleType } from "@/types";
import { WeightResponsibleType } from "@/types";
import * as z from "zod";

const transportResponsible: z.ZodType<TransportResponsibleType> = z.any();
const weightResponsible: z.ZodType<WeightResponsibleType> = z.any();
const TransportBaseSchema = z.object({
  transportResponsible: transportResponsible,
  weightResponsible: weightResponsible,
});

export const TransportSchema = TransportBaseSchema;
export type TransportInput = z.infer<typeof TransportSchema>;

const DifferentAddress = z.object({
  address: z
    .string({
      required_error: "validation:addressRequired",
      invalid_type_error: "validation:addressRequired",
    })
    .min(1, { message: "validation:addressRequired" }),
  countryId: z
    .number({
      required_error: "validation:countryRequired",
      invalid_type_error: "validation:countryRequired",
    })
    .min(1, { message: "validation:countryRequired" }),
  postCode: z
    .string({
      required_error: "validation:postCodeRequired",
      invalid_type_error: "validation:postCodeRequired",
    })
    .min(1, { message: "validation:postCodeRequired" }),

  place: z
    .string({
      required_error: "validation:placeRequired",
      invalid_type_error: "validation:placeRequired",
    })
    .min(1, { message: "validation:placeRequired" }),
  addressType: z.any().optional(),
});

export const DifferentAddressSchema = DifferentAddress;
export type DifferentAddressInput = z.infer<typeof DifferentAddressSchema>;
